import axios from 'axios'
import baseService from './baseService'
import serviceVideo from './data/serviceVideo'

const serviceVideoService = {
  getSupplierServiceVideoInformation (token) {
    return new Promise((resolve, reject) => {
      if (baseService.isTestMode) {
        resolve(serviceVideo.all.find((x) => x.id === 1))
      } else {
        axios
          .get('servicevideo/supplier/getservicevideoinformation', { params: { token: token } }, baseService.defaultConfig)
          .then(response => {
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response.data)
          })
      }
    })
  },
  getCustomerServiceVideoInformation (token) {
    return new Promise((resolve, reject) => {
      if (baseService.isTestMode) {
        resolve(serviceVideo.all.find((x) => x.id === 1))
      } else {
        axios
          .get('servicevideo/customer/getservicevideoinformation', { params: { token: token } }, baseService.defaultConfig)
          .then(response => {
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response.data)
          })
      }
    })
  }

}

export default serviceVideoService
